import { render } from "./EnbMsg.vue?vue&type=template&id=2ceba402&scoped=true"
import script from "./EnbMsg.vue?vue&type=script&lang=js"
export * from "./EnbMsg.vue?vue&type=script&lang=js"

import "./EnbMsg.vue?vue&type=style&index=0&id=2ceba402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceba402"]])

export default __exports__